export const en: Record<string, string> = {
  // Nav
  'nav.dashboard': 'Dashboard',
  'nav.products': 'Products',
  'nav.tasks': 'Tasks',
  'nav.approvals': 'Approvals',
  'nav.actions': 'Actions',
  'nav.settings': 'Settings',

  // Auth
  'auth.signin': 'Sign in',
  'auth.signing_in': 'Signing in...',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.signout': 'Sign out',

  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.sync': 'Catalog Sync',
  'dashboard.sync_catalog': 'Sync Catalog',
  'dashboard.run_analysis': 'Run Analysis',
  'dashboard.syncing': 'Syncing...',
  'dashboard.analyzing': 'Analyzing...',
  'dashboard.score_distribution': 'Score Distribution',
  'dashboard.common_issues': 'Common Issues',
  'dashboard.summary': 'Summary',
  'dashboard.store_health': 'Store Health',
  'dashboard.health_trend': 'Health Trend',
  'dashboard.total_products': 'Total Products',
  'dashboard.avg_score': 'Avg Score',

  // Products
  'products.title': 'Products',
  'products.loading': 'Loading products...',
  'products.empty': 'No products found. Try syncing your catalog first.',
  'products.filter_category': 'Filter by category...',
  'products.score_breakdown': 'Score Breakdown',
  'products.back': 'Back',
  'products.not_analyzed': 'Not analyzed',

  // Tasks
  'tasks.title': 'Tasks',
  'tasks.new': 'New Task',
  'tasks.create': 'Create Task',
  'tasks.creating': 'Creating...',
  'tasks.goal': 'Goal',
  'tasks.max_products': 'Max Products',
  'tasks.max_score': 'Max Score Filter',
  'tasks.tone': 'Tone (optional)',
  'tasks.preserve_html': 'Preserve HTML formatting',
  'tasks.approval_mode': 'Approval Mode',
  'tasks.manual': 'manual',
  'tasks.assisted': 'assisted',
  'tasks.approve_plan': 'Approve Plan',
  'tasks.reject': 'Reject',
  'tasks.pause': 'Pause',
  'tasks.resume': 'Resume',
  'tasks.cancel': 'Cancel Task',
  'tasks.diagnostic': 'Diagnostic',
  'tasks.plan': 'Plan',
  'tasks.steps': 'Steps',
  'tasks.changes': 'Changes',
  'tasks.results': 'Results',

  // Approvals
  'approvals.title': 'Approvals',
  'approvals.loading': 'Loading approvals...',
  'approvals.empty': 'No pending approvals. All clear!',
  'approvals.approve': 'Approve',
  'approvals.reject': 'Reject',
  'approvals.already_decided': 'Already decided from another interface',

  // Actions
  'actions.title': 'Action Log',
  'actions.loading': 'Loading actions...',
  'actions.empty': 'No actions recorded yet.',
  'actions.rollback': 'Rollback',
  'actions.rolling_back': 'Rolling back...',
  'actions.expired': 'Expired',

  // Settings
  'settings.title': 'Settings',
  'settings.account': 'Account',
  'settings.credentials': 'Bitrix Credentials',
  'settings.test_connection': 'Test Connection',
  'settings.save': 'Save',
  'settings.testing': 'Testing...',
  'settings.saving': 'Saving...',
  'settings.webhook_url': 'Webhook URL',
  'settings.catalog_id': 'Catalog Infoblock ID',
  'settings.price_type_id': 'Price Type ID',
  'settings.review_id': 'Review Infoblock ID (optional)',
  'settings.portal_config': 'Portal Configuration',
  'settings.portal_connected': 'Connected via Bitrix24',
  'settings.select_catalog': 'Select catalog...',
  'settings.select_price_type': 'Select price type...',
  'settings.save_config': 'Save Configuration',
  'settings.redetect': 'Re-detect catalogs',
  'settings.config_saved': 'Configuration saved',

  // Subscription
  'subscription.title': 'Subscription',
  'subscription.plan': 'Plan',
  'subscription.status_active': 'Active',
  'subscription.status_trial': 'Trial',
  'subscription.status_expired': 'Expired',
  'subscription.products_usage': 'Products',
  'subscription.tasks_usage': 'Tasks this month',
  'subscription.unlimited': 'Unlimited',
  'subscription.expires': 'Expires',
  'subscription.upgrade': 'Upgrade',

  // Telegram
  'telegram.connect_title': 'Connect Telegram',
  'telegram.connect_description':
    'Scan the QR code or tap the button to connect the Telegram bot for store management',
  'telegram.open_in_telegram': 'Open in Telegram',
  'telegram.qr_expiry': 'QR code is valid for 10 minutes',
  'telegram.connected': 'Telegram connected',
  'telegram.not_connected': 'Telegram not connected',
  'telegram.reconnect': 'Reconnect',
  'telegram.generating': 'Generating link...',
  'telegram.manage_via_bot': 'Manage your store via @SalesAutopilot_bot',
  'telegram.generate_error': 'Failed to generate link. Please try again.',

  // Orders
  'orders.title': 'Orders',
  'orders.loading': 'Loading orders...',
  'orders.empty': 'No orders yet.',
  'orders.total_count': 'orders',
  'orders.number': 'Number',
  'orders.date': 'Date',
  'orders.customer': 'Customer',
  'orders.status': 'Status',
  'orders.total': 'Total',
  'orders.order': 'Order',
  'orders.not_found': 'Order not found',
  'orders.items': 'Items',
  'orders.item_name': 'Name',
  'orders.quantity': 'Qty',
  'orders.price': 'Price',
  'orders.item_total': 'Total',
  'orders.payment': 'Payment',
  'orders.shipment': 'Shipment',

  // Low Stock
  'low_stock.title': 'Low Stock',
  'low_stock.and_more': 'and ${count} more',

  // Weekly Trends
  'weekly_trends.title': 'Weekly Trends',
  'weekly_trends.avg_revenue': 'Avg Revenue',
  'weekly_trends.total_orders': 'Total Orders',
  'weekly_trends.top_day': 'Top Day',

  // Store Status
  'store_status.title': 'Store Status',
  'store_status.orders': 'Orders',
  'store_status.revenue': 'Revenue',
  'store_status.avg_order': 'Avg Order',
  'store_status.today': 'Today',
  'store_status.details_in_telegram': 'Details in Telegram — /today',
  'store_status.no_data': 'No sales data',

  // Common
  'common.loading': 'Loading...',
  'common.coming_soon': 'Coming soon',
  'common.error': 'Error',
  'common.try_again': 'Try Again',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.page': 'Page',
  'common.of': 'of',
};
